import { GatsbyImage } from 'gatsby-plugin-image';
import { useContentfulImage } from 'gatsby-theme-hem-store/src/hooks/useContentfulImage';
import React from 'react';

export const GatsbyContentfulImage = ({
  imageUrl,
  size = 460,
  alt,
  ...props
}: {
  imageUrl: string;
  size?: number;
  alt: string;
  [x: string]: unknown;
}) => {
  const dynamicImage = useContentfulImage(imageUrl, size);
  return <GatsbyImage alt={alt} image={dynamicImage} {...props} />;
};
